// @flow

import toWellFormed from 'core-js-pure/actual/string/to-well-formed'
// Browser entry points on purpose: the Node ones use Buffer, which would make
// the Buffer-based size checks in tests compare the code with itself
import byteLength from 'utf8-byte-length/browser'
import truncateUtf8 from 'truncate-utf8-bytes/browser'

export { byteLength }

// Replaces only broken surrogates, so the size is counted and cut on valid UTF-16
export const toText = (value: mixed): string => (value == null ? '' : toWellFormed(String(value)))

export const truncateBytes = (value: mixed, maxBytes: number): string =>
  truncateUtf8(toText(value), maxBytes)

// Single-line text within a byte limit, for the screen lines and payload fields
export const limitText = (value: mixed, maxBytes: number): string =>
  truncateBytes(toText(value).replace(/\s+/g, ' ').trim(), maxBytes).trim()

export const joinNonEmpty = (parts: Array<string>, separator: string): string =>
  parts.filter((part) => part.length > 0).join(separator)
